// @spec INC-STR-002
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { QuickReportForm } from '@/features/incidents/components/QuickReportForm';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/incidents/quick-report')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.quickIncidentReport'),
  }),
  component: QuickReportPage,
});

function QuickReportPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-3xl space-y-6">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">Quick Incident Report</h1>
          <p className="mt-1 text-muted-foreground">
            Submit a minimal internal report with optional attachment.
          </p>
        </header>
        <QuickReportForm />
      </div>
    </div>
  );
}
